import { z } from 'zod';

export const FORM_SCHEMA = z.object({
  mode: z.enum(['BASIC', 'ADVANCED'])
});

/** @type {z.infer<typeof FORM_SCHEMA>} */
export const DEFAULT_FORM_DATA = {
  mode: 'BASIC'
};

export const RETURN_MODES = FORM_SCHEMA.shape.mode.Values;
